<template>
  <transition-group name="toast" tag="div" class="lm-toast-container">
    <div
      v-for="t in toasts"
      :key="t.id"
      class="lm-toast"
      :class="['lm-toast-' + t.type]"
    >
      <span class="lm-toast-icon">
        <svg v-if="t.type === 'success'" viewBox="0 0 24 24" width="20" height="20"><path fill="currentColor" d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>
        <svg v-else-if="t.type === 'error'" viewBox="0 0 24 24" width="20" height="20"><path fill="currentColor" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
        <svg v-else-if="t.type === 'warning'" viewBox="0 0 24 24" width="20" height="20"><path fill="currentColor" d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/></svg>
        <svg v-else viewBox="0 0 24 24" width="20" height="20"><path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/></svg>
      </span>
      <span class="lm-toast-msg">{{ t.message }}</span>
    </div>
  </transition-group>
</template>

<script>
import { reactive } from 'vue';

// 模块级响应式状态，所有 Toast 共享
const toastState = reactive({
  list: []
});

let nextId = 1;

function show(message, type = 'info', duration = 2000) {
  const id = nextId++;
  const msg = String(message == null ? '' : message);
  toastState.list.push({ id, message: msg, type });
  setTimeout(() => {
    const idx = toastState.list.findIndex(t => t.id === id);
    if (idx >= 0) toastState.list.splice(idx, 1);
  }, duration);
}

export const toast = {
  success: (msg, duration = 2000) => show(msg, 'success', duration),
  error:   (msg, duration = 2500) => show(msg, 'error', duration),
  warning: (msg, duration = 2500) => show(msg, 'warning', duration),
  info:    (msg, duration = 2000) => show(msg, 'info', duration),
  clear:   () => { toastState.list.splice(0); }
};

export default {
  name: 'GlobalToast',
  computed: {
    toasts() {
      return toastState.list;
    }
  }
};
</script>

<style scoped>
.lm-toast-container {
  position: fixed;
  top: 80px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 99999;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  pointer-events: none;
  max-width: 90vw;
}

.lm-toast {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 18px;
  color: #fff;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.4;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(8px);
  min-width: 200px;
  max-width: 500px;
  pointer-events: auto;
}

.lm-toast-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.22);
  flex-shrink: 0;
}

.lm-toast-msg {
  flex: 1;
  word-break: break-word;
  white-space: pre-wrap;
}

.lm-toast-success { background: linear-gradient(135deg, #34d399 0%, #10b981 100%); }
.lm-toast-error   { background: linear-gradient(135deg, #f87171 0%, #ef4444 100%); }
.lm-toast-warning { background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%); }
.lm-toast-info    { background: linear-gradient(135deg, #60a5fa 0%, #3b82f6 100%); }

.toast-enter-active, .toast-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.toast-enter-from {
  opacity: 0;
  transform: translateY(-20px) scale(0.95);
}
.toast-leave-to {
  opacity: 0;
  transform: translateY(-20px) scale(0.95);
}
</style>
